import type { FaireProductEntity } from "../../entity_types/product";

export const p_5u4wm8xk55: FaireProductEntity = {
  token: "p_5u4wm8xk55",
  type: "product",
  name: "Larimar Sphere",
  brandToken: "b_2qbyxhh869",
  brandName: "Prettygoods",
  imageUrl:
    "https://cdn.faire.com/fastly/9d7e111b02f4e84014a6a453d723824eb4ef8bf553fce0cc381ebae64768a915.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f29426c18e45514a34849da02fa8cdb5a7426393de6d5233e990a9a2182ccbd.jpeg",
    "https://cdn.faire.com/fastly/4fd643bf519832765a9639a75ed2a5372d28afd12e465ff15b5c154e7b026400.jpeg",
    "https://cdn.faire.com/fastly/8402f36f63611a9834c23a3e4323a07b3053c0edb1e354d4af40c310819c142c.jpeg",
  ],
  priceDollars: 42.96,
  description:
    "Larimar is a unique blue gemstone found only in a single, remote mountain area of the Dominican Republic, making it a rare and exclusive material. Genuine Larimar sphere for sale. You will receive the item pictured. All of our crystals, minerals, and specimens are 100% authentic and mined from the earth.",
  tags: [],
  msrpDollars: 85.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:45.627Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
